import {create} from 'zustand'
import {
  DatoscuentabtablaModel,
  DatoscuentabtablaModel1,
  TipoDestinatarioModel,
} from '../../../profile/core/_models'
import axios from 'axios'
import {getTiposDestinatarios} from '../../../profile/core/_requests'

import {useIntl} from 'react-intl'
import { WizardCuestionarioModel } from '../../core/_models'
import { getCuestionario } from '../../core/_requests'

interface MyDataMoneda {
  message: {
    msg_id: string
    msg_txt: string
  }
  registro: Moneda[]
}
interface Moneda {
  id_moneda: number
  iso2pais: string
  moneda: string
  nombre: string
  nombrePais: string
}

interface WizardParamsModel {
  iso2pais: string
  moneda: number
}
interface Type_Store {
  bancos: DatoscuentabtablaModel1[]
  updateBancos: () => void

  bancosWizard: DatoscuentabtablaModel1[]
  updateBancosWizard:(by: DatoscuentabtablaModel1[]) => void

  bancosWizardDes: DatoscuentabtablaModel1[]
  updateBancosWizardDes:(by: DatoscuentabtablaModel1[]) => void

  tipoDestinatarios: TipoDestinatarioModel[]
  updateTipoDestinatarios: () => void

  monedasCotizadorEnviar: Moneda[]
  updateMonedasCotizadorEnviar: () => void

  preguntasCuestionario: WizardCuestionarioModel
  updatePreguntasCuestionario: (usuario: number, Language: string) => void
}

export const cargaDatosStore = create<Type_Store>((set) => ({
  bancos: [
    {
      id_prod_financieros: 0,
      idBanco: 0,
      iso2pais: '',
      nombreCorto: '',
      nombrepais: '',
      nombreLargo: '',
      id_moneda: 0,
      nombreMoneda: '',
      moneda: '',
      labelv_CCI: '',
      labelv_Nro_Cta: '',
      labelv_Titular_Cta: '',
      labelv_celular_destinatario: '',
      labelv_correo_destinatario: '',
      labelv_iban: '',
      labelv_clabe: '',
      labelv_cedula: '',
      labelv_TipoDocumento: '',
      labeli_NroDocumento: '',
      labeli_NacionalidadBenef: '',
      labelv_Cod_Envio : '',
      labelv_Nro_Tarjeta : '',
    },
  ],

  updateBancos: async () => {
    try {
      const response = await axios.post<DatoscuentabtablaModel>(
        `${process.env.REACT_APP_API_URL2}/Cat_Bancos/Lista_BancosPf_O`,
        {
          cantidad_max: '200',
          language: 'ES',
          filters: [
            {
              campo: 'iso2pais',
              operador: 'EQ',
              valor1: '',
              valor2: '',
              tipo: 'string',
            },
          ],
        }
      )
      // const response = await fetch(`${process.env.REACT_APP_API_URL2}/CatBancos/Bancos_Read_All`);
      const bancos = response.data.registro

      set({bancos})
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  },

  bancosWizard: [
  ],

  updateBancosWizard : (by) => {
    set({bancosWizard: by})
  },

  bancosWizardDes: [
  ],

  updateBancosWizardDes : (by) => {
    set({bancosWizardDes: by})
  },

  tipoDestinatarios: [
    {
      id_tipo_destinatario: 0,
      descripcion: '',
      activo: '',
    },
  ],

  updateTipoDestinatarios: async () => {
    try {
      const {data: nuevotel} = await getTiposDestinatarios()
      // const response = await fetch(`${process.env.REACT_APP_API_URL2}/CatBancos/Bancos_Read_All`);
      const tipoDestinatarios = nuevotel.registro

      set({tipoDestinatarios})
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  },

  monedasCotizadorEnviar: [
    {
      id_moneda: 0,
      iso2pais: '',
      moneda: '',
      nombre: '',
      nombrePais: '',
    },
  ],

  updateMonedasCotizadorEnviar: async () => {
    try {
      const response = await axios.post<MyDataMoneda>(
        `${process.env.REACT_APP_API_URL2}/Cat_Monedas/Enviar`,
        {
          cantidad_max: '200',
          language: 'ES',
          filters: [
            {
              campo: 'iso2pais',
              operador: 'EQ',
              valor1: '',
              valor2: '',
              tipo: 'string',
            },
          ],
        }
      )
      const monedasCotizadorEnviar = response.data.registro
      console.log(monedasCotizadorEnviar);
      set({monedasCotizadorEnviar})
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  },

  preguntasCuestionario: {
    message: {
      msg_id: '0',
      msg_txt: 'Registros Encontrados',
    },
    registro: [],
  },

  updatePreguntasCuestionario: async (usuario, Language) => {
    try {
      const {data: preguntasCuestionario} = await getCuestionario(usuario, Language)
      set({preguntasCuestionario})
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  },

 
}))
